export const buildTotalsChartData = (summary = {}, activeYears = []) => {
  const allowedYears = new Set(
    Array.isArray(activeYears)
      ? activeYears.map(Number).filter(Number.isFinite)
      : [],
  );

  return Object.entries(summary ?? {})
    .filter(([year]) => {
      if (allowedYears.size === 0) return true;
      return allowedYears.has(Number(year));
    })
    .sort(([left], [right]) => Number(left) - Number(right))
    .map(([year, values]) => ({
      year,
      scope1: values.scope1 ?? 0,
      scope2: values.scope2 ?? 0,
      scope3: values.scope3 ?? 0,
      total: values.total ?? 0,
    }));
};

export const buildReportingPeriodLabel = (activeYears = []) => {
  const years = Array.isArray(activeYears)
    ? activeYears.map(Number).filter(Number.isFinite)
    : [];

  if (years.length === 0) return "all reporting years";
  if (years.length === 1) return `reporting year ${years[0]}`;

  return `reporting years ${years[0]}-${years[years.length - 1]}`;
};
